<template>
    <div class="container">
        <form-site-management :site_management="site_management" @is-form-dirty="isFormDirty" />
    </div>
</template>

<script>
import FormSiteManagement from '@/components/forms/SiteManagement.vue';

export default {
    components: {
        FormSiteManagement,
    },
    props: {
        site_management: Object,
    },
    methods: {
        isFormDirty(is_dirty) {
            this.$emit('is-form-dirty', is_dirty);
        },
    },
};
</script>
